/**
 * Determine the mobile operating system and THDConsumer version.
 * User agent sniffing isn't that good for getting OS, but we can be sure it's mobile if we only use this alongside isConsumerApp check
 *
 * @returns {Object} An object containing the version and os fields
 */
export var getMobileOSAndVersion = function () {
    var userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || (navigator === null || navigator === void 0 ? void 0 : navigator.vendor) || '';
    // Determine the mobile operating system
    var os = 'iOS';
    if (/android/i.test(userAgent)) {
        os = 'Android';
    }
    // Get the THDConsumer version
    var regex = /THDConsumer\/([\d.]+)/;
    var match = userAgent.match(regex);
    var version = match ? match[1] : '';
    return { os: os, version: version };
};
/**
 * Compares two version strings in the format "x.y.z".
 *
 * @param {string} userVersion - First version string.
 * @param {string} minimumVersion - Second version string.
 * @returns {boolean} false if userVersion < minimumVersion, true if userVersion => minimumVersion
 */
export var checkTHDConsumerVersion = function (userVersion, minimumVersion) {
    var v1Parts = userVersion.split('.').map(Number);
    var v2Parts = minimumVersion.split('.').map(Number);
    for (var i = 0; i < Math.max(v1Parts.length, v2Parts.length); i += 1) {
        var v1Part = v1Parts[i] || 0;
        var v2Part = v2Parts[i] || 0;
        if (v1Part < v2Part) {
            return false;
        }
        if (v1Part > v2Part) {
            return true;
        }
    }
    return true;
};
